export class Parametro {
  edadMinima: number = 16;
  edadMaxima: number = 78;
  estadoSitio: boolean = true;
}
